<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center gap-2">
    <div class="flex-1">
      <mat-card-title class=""
        >{{ edit ? 'Editar' : 'Adicionar' }} item proposta</mat-card-title
      >
    </div>
    @if (!checkdate()) {
      <mat-icon
        [matTooltip]="'A data o item diverge com a data da proposta'"
        fontIcon="info"
        class="alert-icon"
      ></mat-icon>
    }
    <button mat-flat-button class="btn-tg-cancel w-1/12" (click)="close()">
      {{ edit ? 'Voltar' : 'Cancelar' }}
    </button>
    <button
      mat-flat-button
      class="btn-tg"
      [ngClass]="!loadingInfo ? `w-2/12` : `w-1/12`"
      [disabled]="!checkForm() || loading"
      (click)="createItemProposal()"
    >
      @if (loading) {
        <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
        @if (!loadingInfo) {
          <div class="style-inline-btn">
            Carregando dados
            <mat-spinner
              diameter="20"
              class="loading-spinner-disabled"
            ></mat-spinner>
          </div>
        } @else {
          {{ edit ? 'Salvar' : 'Adicionar' }}
        }
      }
    </button>
  </mat-card-header>
  <div class="my-4"></div>
  <div>
    <mat-accordion multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title> <h4>Item Proposta</h4> </mat-panel-title>
        </mat-expansion-panel-header>
        <div [formGroup]="form" class="mt-4 container mx-auto">
          <div class="mb-3">
            <search-tariff-proposal
              (selectItemEvent)="selectTariff($event)"
              (locationEvent)="locationTariff($event)"
              [tariffSelected]="tariffSelected"
              [idClient]="idClient"
              (loadingEnd)="loadingEnd($event)"
            />
          </div>
          <div class="flex justify-between items-center mt-8 -mx-2">
            <mat-form-field
              class="input-tg w-2/12 px-2 no-message-new"
              appearance="outline"
            >
              <mat-label>Valor custo</mat-label>
              @if (form.get('cost')!.value != '') {
                <span matTextPrefix>R$&nbsp;</span>
              }
              <input matInput formControlName="cost" currencyInput />
            </mat-form-field>

            <!--            <mat-form-field-->
            <!--              class="input-tg w-2/12 px-2 no-message-new"-->
            <!--              appearance="outline"-->
            <!--            >-->
            <!--              <mat-label>Custo hora extra</mat-label>-->
            <!--              @if (form.get('costOvertime')!.value != '') {-->
            <!--                <span matTextPrefix>R$&nbsp;</span>-->
            <!--              }-->
            <!--              <input matInput formControlName="costOvertime" currencyInput />-->
            <!--            </mat-form-field>-->

            <!--            <mat-form-field-->
            <!--              class="input-tg w-2/12 px-2 no-message-new"-->
            <!--              appearance="outline"-->
            <!--            >-->
            <!--              <mat-label>Custo Km extra</mat-label>-->
            <!--              @if (form.get('costKmExtra')!.value != '') {-->
            <!--                <span matTextPrefix>R$&nbsp;</span>-->
            <!--              }-->
            <!--              <input matInput formControlName="costKmExtra" currencyInput />-->
            <!--            </mat-form-field>-->

            <div class="w-6/12 px-2">
              <div class="box-form">
                <h4 class="bg-gray">Comissão | Divisor | Taxa</h4>
                <div class="input-box flex justify-between items-center w-full">
                  <mat-form-field
                    class="input-tg w-3/12 px-2 no-message-new"
                    appearance="outline"
                  >
                    <mat-label>Tipo</mat-label>
                    <mat-select
                      formControlName="typeCommission"
                      (selectionChange)="onSelectionChangeType($event)"
                    >
                      @for (type of listCommission; track type) {
                        <mat-option
                          [value]="type.value"
                          [disabled]="type.disabled"
                        >
                          {{ type.description }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field
                    class="input-tg w-3/12 px-2 no-message-new"
                    appearance="outline"
                  >
                    <mat-label>Comissão</mat-label>
                    @if (form.get('commission')!.value != '') {
                      <span matTextSuffix>%&nbsp;</span>
                    }
                    <input
                      matInput
                      formControlName="commission"
                      decimalInput
                      (blur)="calculateValues()"
                    />
                  </mat-form-field>
                  <mat-form-field
                    class="input-tg w-3/12 px-2 no-message-new"
                    appearance="outline"
                  >
                    <mat-label>Divisor</mat-label>
                    <input
                      matInput
                      formControlName="divider"
                      decimalInput
                      (blur)="calculateValues()"
                    />
                  </mat-form-field>
                  <mat-form-field
                    class="input-tg w-3/12 px-2 no-message-new"
                    appearance="outline"
                  >
                    <mat-label>Taxa</mat-label>
                    @if (form.get('tax')!.value != '') {
                      <span matTextSuffix>%&nbsp;</span>
                    }
                    <input
                      matInput
                      formControlName="tax"
                      currencyInput
                      (blur)="calculateValues()"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <mat-form-field
              class="input-tg w-2/12 px-2 no-message-new"
              appearance="outline"
            >
              <mat-label>Quant. veículo</mat-label>
              <input
                matInput
                formControlName="numVehicle"
                integerInput
                (blur)="calculateValues()"
              />
            </mat-form-field>

            <mat-form-field
              class="input-tg w-2/12 px-2 no-message-new"
              appearance="outline"
            >
              <mat-label>Quant. pessoas</mat-label>
              <input matInput formControlName="numPeople" integerInput />
            </mat-form-field>
          </div>
          <div class="flex justify-between items-center mt-8 mb-5 -mx-2">
            <div class="w-full px-2">
              <div class="box-form">
                <h4 class="bg-gray">Venda</h4>
                <div class="input-box flex justify-between items-center w-full">
                  <mat-form-field
                    class="input-tg w-2/12 px-2 no-message-new"
                    appearance="outline"
                  >
                    <mat-label>Valor unitário</mat-label>
                    @if (form.get('saleUnit')!.value != '') {
                      <span matTextPrefix>R$&nbsp;</span>
                    }
                    <input matInput formControlName="saleUnit" currencyInput />
                  </mat-form-field>

                  <mat-form-field
                    class="input-tg w-2/12 px-2 no-message-new"
                    appearance="outline"
                  >
                    <mat-label>Hora extra</mat-label>
                    @if (form.get('saleOvertime')!.value != '') {
                      <span matTextPrefix>R$&nbsp;</span>
                    }
                    <input
                      matInput
                      formControlName="saleOvertime"
                      currencyInput
                    />
                  </mat-form-field>

                  <mat-form-field
                    class="input-tg w-2/12 px-2 no-message-new"
                    appearance="outline"
                  >
                    <mat-label>Km extra</mat-label>
                    @if (form.get('saleKmExtra')!.value != '') {
                      <span matTextPrefix>R$&nbsp;</span>
                    }
                    <input
                      matInput
                      formControlName="saleKmExtra"
                      currencyInput
                    />
                  </mat-form-field>

                  <mat-form-field
                    class="input-tg w-2/12 px-2 no-message-new"
                    appearance="outline"
                  >
                    <mat-label>Valor sem Taxa</mat-label>
                    @if (form.get('saleTotal')!.value != '') {
                      <span matTextPrefix>R$&nbsp;</span>
                    }
                    <input matInput formControlName="saleTotal" currencyInput />
                  </mat-form-field>

                  <mat-form-field
                    class="input-tg w-2/12 px-2 no-message-new"
                    appearance="outline"
                  >
                    <mat-label>Valor taxa</mat-label>
                    @if (form.get('taxValue')!.value != '') {
                      <span matTextPrefix>R$&nbsp;</span>
                    }
                    <input matInput formControlName="taxValue" currencyInput />
                  </mat-form-field>

                  <mat-form-field
                    class="input-tg w-2/12 px-2 no-message-new"
                    appearance="outline"
                  >
                    <mat-label>Valor com Taxa</mat-label>
                    @if (form.get('saleTotalTax')!.value != '') {
                      <span matTextPrefix>R$&nbsp;</span>
                    }
                    <input
                      matInput
                      formControlName="saleTotalTax"
                      currencyInput
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>

          <div class="flex justify-between items-center mt-8 mb-5 -mx-2">
            <div class="w-4/12 px-2">
              <div class="box-form">
                <h4 class="bg-gray">Inicio</h4>
                <div class="input-box flex justify-between items-center w-full">
                  <mat-form-field
                    class="input-tg w-8/12 px-2 no-message-new"
                    appearance="outline"
                  >
                    <mat-label>Data</mat-label>
                    <input
                      matInput
                      [matDatepicker]="dateStart"
                      (focus)="openDatepicker('dateStart')"
                      formControlName="dateStart"
                      [max]="this.form.get('dateEnd')!.value"
                      readonly
                      (dateChange)="onDateChange()"
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="dateStart"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #dateStart></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field
                    class="input-tg w-4/12 px-2 no-message-new"
                    appearance="outline"
                  >
                    <mat-label>Hora (24h)</mat-label>
                    <input matInput type="time" formControlName="timeStart" />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="w-4/12 px-2">
              <div class="box-form">
                <h4 class="bg-gray">Fim</h4>
                <div class="input-box flex justify-between items-center w-full">
                  <mat-form-field
                    class="input-tg w-8/12 px-2 no-message-new"
                    appearance="outline"
                  >
                    <mat-label>Data</mat-label>
                    <input
                      matInput
                      [matDatepicker]="dateEnd"
                      (focus)="openDatepicker('dateEnd')"
                      formControlName="dateEnd"
                      readonly
                      [min]="this.form.get('dateStart')!.value"
                      (dateChange)="onDateChange()"
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="dateEnd"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #dateEnd></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field
                    class="input-tg w-4/12 px-2 no-message-new"
                    appearance="outline"
                  >
                    <mat-label>Hora (24h)</mat-label>
                    <input matInput type="time" formControlName="timeEnd" />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <!--            <mat-form-field-->
            <!--              class="input-tg w-2/12 px-2 no-message-new"-->
            <!--              appearance="outline"-->
            <!--            >-->
            <!--              <mat-label>Quant. veículo</mat-label>-->
            <!--              <input-->
            <!--                matInput-->
            <!--                formControlName="numVehicle"-->
            <!--                integerInput-->
            <!--                (blur)="calculateValues()"-->
            <!--              />-->
            <!--            </mat-form-field>-->

            <!--            <mat-form-field-->
            <!--              class="input-tg w-2/12 px-2 no-message-new"-->
            <!--              appearance="outline"-->
            <!--            >-->
            <!--              <mat-label>Quant. pessoas</mat-label>-->
            <!--              <input matInput formControlName="numPeople" integerInput />-->
            <!--            </mat-form-field>-->
            <mat-checkbox class="input-tg w-1/12" formControlName="isCourtesy"
              ><h3>Cortesia</h3></mat-checkbox
            >
            <mat-checkbox class="input-tg w-1/12" formControlName="isExchange"
              ><h3>Permuta</h3></mat-checkbox
            >
            <mat-checkbox class="input-tg w-2/12" formControlName="isCommission"
              ><h3>Se comissiona</h3></mat-checkbox
            >
          </div>
          <div class="flex justify-between items-center mt-8 mb-5 -mx-2">
            <mat-form-field
              class="input-tg w-full px-2 no-message-new"
              appearance="outline"
            >
              <mat-label>Observação</mat-label>
              <textarea matInput formControlName="observation"></textarea>
            </mat-form-field>
          </div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title> <h4>Itinerários</h4> </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <itineraries-item-proposal-create
            [listItineraries]="listItineraries"
            [tariffSelected]="tariffSelected"
            (response)="getList($event)"
          />
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</mat-card>
